module.exports = __webpack_public_path__ + "img/undraw_team_ih79.b0e912c4.svg";